import { getService } from "../../services";
import type { LandingPagePreviewBody, LandingPagePreviewResponse } from "../../../../common/types/restApiTypes";
import type LandingPagePreviewServices from "../../../logic/common/landingPagePreviewServices";

export async function getLandingPagePreviewUrl(accountId: string, programId: string, previewBody: LandingPagePreviewBody): Promise<LandingPagePreviewResponse> {
    return getService<LandingPagePreviewServices>("landingPagePreviewServices").getLandingPagePreviewUrl(accountId, programId, previewBody);
}
